import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { ExternalLink, Newspaper } from "lucide-react";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function News() {
  const [news, setNews] = useState([]);
  const { t, lang } = useLang();

  useEffect(() => {
    axios.get(`${API}/news`).then((r) => setNews(r.data)).catch(() => {});
  }, []);

  if (news.length === 0) return null;

  return (
    <section id="news" className="py-24 sm:py-32 border-b border-white/10" data-testid="news-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="overline-tag" data-testid="news-overline">
          {t.news.overline}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
          className="mt-4 font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-3xl"
        >
          {t.news.h2}
        </motion.h2>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {news.map((item, i) => (
            <motion.article
              key={item.id}
              initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 3) * 0.1 }}
              className="glass rounded-2xl p-7 flex flex-col hover:border-volt/40 transition-colors duration-300" data-testid={`news-card-${i}`}
            >
              <div className="flex items-center gap-3">
                <Newspaper size={16} className="text-volt shrink-0" />
                {item.tag && <span className="text-xs font-medium text-volt border border-volt/30 rounded-full px-3 py-0.5">{item.tag}</span>}
                <span className="text-xs text-steel ml-auto">{item.data}</span>
              </div>
              <h3 className="mt-4 font-display font-semibold text-lg leading-snug">{lang === "en" && item.titolo_en ? item.titolo_en : item.titolo}</h3>
              <p className="mt-2 text-sm text-steel leading-relaxed flex-1">{lang === "en" && item.testo_en ? item.testo_en : item.testo}</p>
              {item.link && (
                <a href={item.link} target="_blank" rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center gap-1.5 text-xs font-medium text-volt hover:underline" data-testid={`news-link-${i}`}>
                  {t.news.readMore} <ExternalLink size={12} />
                </a>
              )}
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
